import { useAuth0 } from '@auth0/auth0-react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useProfileStorage from '../../hooks/useProfileStorage';
import Layout from '../Layout';
import LoadingPage from '../Loading/Page';
import useSubmitForm from './useSubmitForm';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
}));

export default function SubmitProfile() {
  const classes = useStyles();
  const { isAuthenticated, isLoading: isLoadingAuth } = useAuth0();
  const history = useHistory();
  const { profile, fetchingProfile } = useProfileStorage();
  const [mutation, submitted, setSubmitted] = useSubmitForm();

  useEffect(() => {
    if (isAuthenticated && !fetchingProfile && profile && !submitted) {
      mutation.mutate(profile);
    }
  }, [profile, fetchingProfile, submitted, isLoadingAuth]);

  let content = null;

  if (isLoadingAuth || fetchingProfile || mutation.isLoading) {
    content = <LoadingPage />;
  } else if (!isAuthenticated) {
    history.goBack();
    return null;
  } else if (mutation.isError) {
    const handleRetryClick = () => {
      if (profile) {
        setSubmitted(false);
        mutation.mutate(profile);
      }
    };
    content = (
      <Box flex padding={5}>
        <Paper className={classes.container}>
          <Typography variant="h2" gutterBottom>
            An error occurred
          </Typography>
          <Typography paragraph>
            There was an error submitting your profile.
          </Typography>
          <Typography paragraph>
            Please try again. If the problem persists,
            contact us with the link in the lower left corner.
          </Typography>
          <Box display="flex" justifyContent="center" pt={2}>
            <Button variant="contained" color="primary" onClick={handleRetryClick}>Submit again</Button>
          </Box>
        </Paper>
      </Box>
    );
  }

  return (
    <Layout>
      {content}
    </Layout>
  );
}
